export var isValidPhone = function (value) {
    if (!/^(0|86|17951)?([0-9][0-9][0-9])[0-9]{8}$/.test(value)
        // eslint-disable-next-line no-useless-escape
        && !/^(0|86|17951)?([0-9][0-9][0-9])[\*]{4}[0-9]{4}$/.test(value)) {
        return false;
    }
    return true;
};
